import React from "react";
import { Button } from "reactstrap";
import { ReactComponent as MsgIcon } from "../../../images/svg_icons/message-white.svg";
import "./styles.scss";

const KnowMore = ({ agentName, onContactAgent, shareLink }) => {
  return (
    <div className="know-more-container">
      <div>
        <p>Want to know more about it?</p>
        <p>
        {shareLink
          ? <>Email <b>{agentName}</b> and get info from the best possible source!</>
          : <>Login / Register to contact your agent for additional information about this listing!</>}
        </p>
      </div>
      <Button
        color="primary"
        className="contact-agent-button"
        onClick={onContactAgent}
      >
        { shareLink ? <>Contact Agent <MsgIcon /></> : <>Login / Register</> }
      </Button>
    </div>
  );
};

export default KnowMore;
